import { Constant as ConstantScale } from '@antv/scale';
export const Constant = (options) => {
    return new ConstantScale(options);
};
Constant.props = {};
//# sourceMappingURL=constant.js.map